export const CONTACT_TYPE_OPTIONS = [
  {
    value: '-',
    text: 'Private',
  },
  {
    value: '1',
    text: 'Other',
  },
  {
    value: '2',
    text: 'Business',
  },
  {
    value: '3',
    text: 'Registered',
  },
] as const;

export type ContactType = (typeof CONTACT_TYPE_OPTIONS)[number]['value'] | '';
